<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4167 0H4.58333C3.36823 0.00152539 2.20334 0.47922 1.34413 1.32832C0.484925 2.17742 0.00154355 3.32861 0 4.52941L0 11.9412C0.00154355 13.142 0.484925 14.2932 1.34413 15.1423C2.20334 15.9914 3.36823 16.4691 4.58333 16.4706H5.78167L9.19833 19.2936C9.42319 19.4794 9.70694 19.5811 10 19.5811C10.2931 19.5811 10.5768 19.4794 10.8017 19.2936L14.2183 16.4706H15.4167C16.6318 16.4691 17.7967 15.9914 18.6559 15.1423C19.5151 14.2932 19.9985 13.142 20 11.9412V4.52941C19.9985 3.32861 19.5151 2.17742 18.6559 1.32832C17.7967 0.47922 16.6318 0.00152539 15.4167 0ZM17.5 11.9412C17.5 12.4872 17.2805 13.0109 16.8898 13.397C16.4991 13.7831 15.9692 14 15.4167 14H13.7642C13.471 14.0002 13.1873 14.1022 12.9625 14.2882L10 16.7358L7.0375 14.2882C6.81275 14.1022 6.52899 14.0002 6.23583 14H4.58333C4.0308 14 3.5009 13.7831 3.11019 13.397C2.71949 13.0109 2.5 12.4872 2.5 11.9412V4.52941C2.5 3.98338 2.71949 3.45971 3.11019 3.0736C3.5009 2.6875 4.0308 2.47059 4.58333 2.47059H15.4167C15.9692 2.47059 16.4991 2.6875 16.8898 3.0736C17.2805 3.45971 17.5 3.98338 17.5 4.52941V11.9412Z"
      fill="currentColor"
    />
    <path
      d="M6.25 7.41102H8.75C9.08152 7.41102 9.39946 7.28087 9.63388 7.04921C9.8683 6.81755 10 6.50334 10 6.17572C10 5.8481 9.8683 5.5339 9.63388 5.30224C9.39946 5.07058 9.08152 4.94043 8.75 4.94043H6.25C5.91848 4.94043 5.60054 5.07058 5.36612 5.30224C5.1317 5.5339 5 5.8481 5 6.17572C5 6.50334 5.1317 6.81755 5.36612 7.04921C5.60054 7.28087 5.91848 7.41102 6.25 7.41102Z"
      fill="currentColor"
    />
    <path
      d="M13.75 9.05859H6.25C5.91848 9.05859 5.60054 9.18874 5.36612 9.4204C5.1317 9.65207 5 9.96627 5 10.2939C5 10.6215 5.1317 10.9357 5.36612 11.1674C5.60054 11.399 5.91848 11.5292 6.25 11.5292H13.75C14.0815 11.5292 14.3995 11.399 14.6339 11.1674C14.8683 10.9357 15 10.6215 15 10.2939C15 9.96627 14.8683 9.65207 14.6339 9.4204C14.3995 9.18874 14.0815 9.05859 13.75 9.05859Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconChat'
}
</script>
